import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Registration} from "../../models/registration";
import {Requirement} from "../../models/requirement";
import Helpers from "../../utils/helpers";

@Injectable()
export class RequirementControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getServiceRequirements(): Observable<Requirement[]> {
    return this.http.get(this.baseUrl + "requirement") as Observable<Requirement[]>;
  }

  public getRequirement(requirementId: string): Observable<Requirement> {
    return this.http.get(this.baseUrl + "requirement/" + requirementId) as Observable<Requirement>;
  }

  public getRequirementRegistrations(fieldKey: string): Observable<Registration[]> {
    return this.http.get(this.baseUrl + "requirement/field/" + fieldKey) as Observable<Registration[]>;
  }

  public createRequirement(requirement: Requirement): Observable<Requirement> {
    Helpers.trimRecursiveObj(requirement);
    const body = JSON.stringify(requirement);
    return this.http.post(this.baseUrl + "requirement", body) as Observable<Requirement>;
  }

  public saveRequirement(requirement: Requirement) {
    Helpers.trimRecursiveObj(requirement);
    const body = JSON.stringify(requirement);
    return this.http.put(this.baseUrl + "requirement", body, {responseType: "text"});
  }

  public deleteRequirement(requirementId: string) {
    return this.http.delete(this.baseUrl + "requirement/" + requirementId, {responseType: "text"});
  }

}
